import {
    IAccount,
    IAccountMappingEmpty,
    IAccountMappingHeader,
    IAccountMappingSubFLI,
    IAccountMappingTemplateGroup,
    IAccountMappingTemplateGroupItemFLI,
    IAccountMappingTemplateGroupItemSubtotal,
    ItemType,
    SortedMappingItem,
} from '@modeso/types__aumico-lib-annualreport-be';
import { Item } from '../interfaces/menu-item.class';

export function isAccount(item: Item): item is IAccount {
    return 'accountNumber' in item;
}

export function isGroup(item: Item | SortedMappingItem): item is IAccountMappingTemplateGroup {
    return 'groups' in item;
}

export function isFli(item: Item): item is IAccountMappingTemplateGroupItemFLI {
    return 'type' in item && item.type === ItemType.FLI;
}

export function isFliNumberingDisable(item: Item): item is IAccountMappingTemplateGroupItemFLI {
    return 'disableNumbering' in item && item.disableNumbering === true;
}

export function isSubfli(item: Item): item is IAccountMappingSubFLI {
    return 'type' in item && (item.type === ItemType.SUB_FLI || item.type === ItemType.OF_THAT_ITEM);
}

export function isOfThatItem(item: Item): item is IAccountMappingSubFLI {
    return 'type' in item && item.type === ItemType.OF_THAT_ITEM;
}

export function isSubTotal(item: Item): item is IAccountMappingTemplateGroupItemSubtotal {
    return 'type' in item && item.type === ItemType.SUB_TOTAL;
}
export function isHeader(item: Item): item is IAccountMappingHeader {
    return ('type' in item && item.type === ItemType.HEADER) || 'isHeader' in item;
}
export function isHeaderGroup(item: Item | SortedMappingItem): item is IAccountMappingTemplateGroup {
    return 'isHeader' in item;
}

export function isEmptyRowGroup(item: Item | SortedMappingItem): item is IAccountMappingTemplateGroup {
    return 'isEmpty' in item;
}
export function isEmpty(item: Item): item is IAccountMappingEmpty {
    return ('type' in item && item.type === ItemType.EMPTY) || 'isEmpty' in item;
}
